export default function Playground() {
  return (
    <div>
      <button className="btn btn-outline-secondary mt-2">
        Edit
        <span
          className="spinner-border spinner-border-sm ms-1"
          role="status"
          aria-hidden="true"
        ></span>
      </button>

      <button className="btn btn-primary mt-2">
        Edit
        <span
          className="spinner-border spinner-border-sm ms-1"
          role="status"
          aria-hidden="true"
        ></span>
      </button>

      <button className="btn btn-link mt-2">
        Edit
        <span
          className="spinner-border spinner-border-sm ms-1"
          role="status"
          aria-hidden="true"
        ></span>
      </button>
    </div>
  );
}
